var map = {
	"./404.svg": "oUrx",
	"./basic.svg": "qMVa",
	"./bug.svg": "F3lI",
	"./chart.svg": "yCkv",
	"./clipboard.svg": "vDVG",
	"./component.svg": "VtY+",
	"./dashboard.svg": "94Jb",
	"./devic.svg": "7GU0",
	"./deviceDeliverReturn.svg": "tHv+",
	"./documentation.svg": "kPu2",
	"./drag.svg": "m7++",
	"./edit.svg": "qkZ8",
	"./email.svg": "y7eQ",
	"./example.svg": "MMMJ",
	"./excel.svg": "ZZmv",
	"./eye.svg": "TfVu",
	"./face.svg": "VSb1",
	"./form.svg": "6xvN",
	"./guide.svg": "ZoO1",
	"./handbook.svg": "NRd7",
	"./icon.svg": "nZHn",
	"./international.svg": "F9+T",
	"./language.svg": "JYDz",
	"./list.svg": "MokB",
	"./lock.svg": "qwAt",
	"./message.svg": "R/8a",
	"./money.svg": "MEYL",
	"./nested.svg": "3PhE",
	"./password.svg": "Kj24",
	"./people.svg": "0Fbn",
	"./peoples.svg": "LxGF",
	"./qq.svg": "FDDl",
	"./setting.svg": "Bf+v",
	"./shoppingCard.svg": "xsEB",
	"./star.svg": "cIpu",
	"./statistics.svg": "oc+f",
	"./systemSettings.svg": "Kx4i",
	"./tab.svg": "j7e1",
	"./table.svg": "R/Hx",
	"./theme.svg": "5TQQ",
	"./user.svg": "s7Vf",
	"./wechat.svg": "gNoN",
	"./zip.svg": "iqZD"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Uf/o";